import { arrayIndices } from "./arrayIndices";
export const arrayMap = (length, cbIterate) => arrayIndices(length).map(cbIterate);
